import { inject, provideAppInitializer } from '@angular/core';
import { type Observable } from 'rxjs';
import { FeatureToggleService } from './feature-toggle.service';

function initializeFeatureToggle(): () => Observable<any> {
  const featureToggleService = inject(FeatureToggleService);
  return () => featureToggleService.getFeatureToggles();
}

export const provideFeatureToggle = () =>
  provideAppInitializer(() => {
    const initializerFn = initializeFeatureToggle();
    return initializerFn();
  });
